export default "__VITE_ASSET__Cxr5Rj_2__"